import { push } from 'connected-react-router';
import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';

export const ADD_ONLINE_FORM_REQUEST = 'ADD_ONLINE_FORM_REQUEST';
export const ADD_ONLINE_FORM_SUCCESS = 'ADD_ONLINE_FORM_SUCCESS';
export const ADD_ONLINE_FORM_FAILURE = 'ADD_ONLINE_FORM_FAILURE';

function requestAddOnlineForm() {
  return {
    type: ADD_ONLINE_FORM_REQUEST,
    isAddingOnlineForm: true
  };
}

function receiveAddOnlineForm() {
  return {
    type: ADD_ONLINE_FORM_SUCCESS,
    isAddingOnlineForm: false
  };
}

export function addOnlineForm(formType, clientId, customerAccount, formReference) {
  const formCategory = formType.includes('crs') || formType.startsWith('rc') ? 'crs' : 'w';

  const postData = {
    isOnline: true,
    client: clientId,
    isNewCustomer: customerAccount && customerAccount.newCustomer,
    customerId: customerAccount && customerAccount.customerId,
    isNewAccount: customerAccount && customerAccount.newAccount,
    accounts: customerAccount && customerAccount.accounts && customerAccount.accounts.length > 0 ? customerAccount.accounts.map(a => a.value) : [],
    legalEntities: customerAccount && customerAccount.legalEntities && customerAccount.legalEntities.length > 0 ? customerAccount.legalEntities.map(le => le.value) : [],
    wForm: formCategory === 'w' ? {
      type: formType
    } : null,
    crsForm: formCategory === 'crs' ? {
      type: formType
    } : null,
    wFormReference: formCategory === 'w' ? formReference : null,
    crsFormReference: formCategory === 'crs' ? formReference : null
  };

  return (dispatch) => {
    dispatch(requestAddOnlineForm());

    const promise = () => ApiService
      .addForm(postData)
      .then((response) => {
        if (response.data.redirectUrl) {
          return dispatch(push(response.data.redirectUrl));
        }
        return dispatch(receiveAddOnlineForm(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          toastr.error(
            'Error',
            error.response?.data?.error?.message
              ? error.response.data.error.message
              : "Something's not quite right. Please try again or speak to your system administrator."
          );
        }
      });
    return promise();
  };
}
